import { useThemeColor } from "@/hooks/useThemeColor";
import React from "react";
import {
  GestureResponderEvent,
  StyleProp as RNStyleProp,
  StyleProp,
  StyleSheet,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from "react-native";
import { ThemedText } from "../ThemedText";

// Define ThemedTextProp as a type alias for React Native text styles
type ThemedTextProp = RNStyleProp<TextStyle>;

type ButtonProps = {
  style?: StyleProp<ViewStyle>;
  textStyle?: ThemedTextProp;
  onPress?: (event: GestureResponderEvent) => void;
  disabled?: boolean;
  text?: string;
  testID?: string;
  icon?: React.ReactNode;
  accessibilityLabel?: string;
};

export const Button: React.FC<ButtonProps> = ({
  onPress,
  disabled,
  text,
  textStyle,
  style,
  testID,
  icon,
  accessibilityLabel,
}) => {
  const primary = useThemeColor({}, "primary");
  const onPrimary = useThemeColor({}, "onPrimary");
  // Use hardcoded colors for disabled state
  const disabledBg = "#A0A0A0";
  const disabledText = "#fff";

  return (
    <TouchableOpacity
      style={[
        styles.button,
        { backgroundColor: disabled ? disabledBg : primary },
        style,
      ]}
      onPress={onPress}
      activeOpacity={0.7}
      disabled={disabled}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      accessibilityState={{ disabled: !!disabled }}
      testID={testID}
    >
      <View style={styles.content}>
        {icon}
        {text ? (
          <ThemedText
            style={[
              styles.text,
              { color: disabled ? disabledText : onPrimary },
              textStyle,
              icon ? { marginLeft: 10 } : {},
            ]}
          >
            {text}
          </ThemedText>
        ) : null}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    width: "100%",
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 12,
    paddingHorizontal: 15,
    maxWidth: 400,
  },
  content: {
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    fontSize: 16,
  },
});
